/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SiteForDisplay
 */
export interface SiteForDisplay {
  /**
   *
   * @type {string}
   * @memberof SiteForDisplay
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof SiteForDisplay
   */
  displayName?: string
}

export function SiteForDisplayFromJSON(json: any): SiteForDisplay {
  return SiteForDisplayFromJSONTyped(json, false)
}

export function SiteForDisplayFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteForDisplay {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    displayName: !exists(json, 'display_name') ? undefined : json['display_name']
  }
}

export function SiteForDisplayToJSON(value?: SiteForDisplay | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    display_name: value.displayName
  }
}
